import React from 'react';
import { useLocation } from 'react-router-dom';
import { DASHBOARD_STYLED_CONSTS, Dashboard } from '@components';
import { Tabs, useMediaQueryContext } from '@fourthwall/components';
import * as S from './NavTabs.styled';
export const NavTabs = ({ tabs, activeTab, onTabClick }) => {
    const media = useMediaQueryContext();
    const { pathname } = useLocation();
    const mobileTabProps = !media.tablet
        ? {
            variant: 'dimmed',
            size: 'medium',
            weight: 'bold',
            scrollable: true,
            scrollIntoView: true,
            scrollIntoViewOffset: DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL,
        }
        : {};
    const findActiveTabIndex = () => {
        for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab.to === pathname || pathname.startsWith(`${tab.to}/`)) {
                return i;
            }
        }
        return 0;
    };
    const defaultIndex = findActiveTabIndex();
    return (React.createElement(Tabs, { direction: "horizontal", defaultIndex: defaultIndex },
        React.createElement(Dashboard.Section.ScrollableContent, { hideScrollbar: true, fullWidth: true },
            React.createElement(Tabs.List, { direction: "horizontal" }, tabs.map(({ label, to, value }) => {
                const isActive = !!activeTab && activeTab === value;
                return (React.createElement(S.Tab, { key: label, to: to, name: label, selected: isActive, onClick: () => {
                        if (onTabClick && value) {
                            onTabClick(value);
                        }
                    }, variant: isActive ? 'default' : 'dimmed', direction: "horizontal", size: "large", ...mobileTabProps }));
            })))));
};
